import { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  Activity,
  BarChart3,
  ChevronDown,
  LayoutDashboard,
  LogOut,
  Menu,
  Settings2,
  ShieldCheck,
  UserCog,
  X,
} from 'lucide-react';
import { MODULES, VILLAGE_MODULE } from '../config/modules';
import { useAuth } from '../context/AuthContext';

const navItemClass = ({ isActive }) => `nav-item ${isActive ? 'active' : ''}`;

export default function AppLayout() {
  const { adminProfile, isSuperAdmin, can, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const location = useLocation();

  const closeNavigation = () => setMobileOpen(false);
  const moduleLinks = Object.entries(MODULES).filter(([key]) => can(key, 'view'));

  return (
    <div className="app-shell">
      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="brand-row">
          <div className="brand-mark">JP</div>
          <div><strong>Jashapar Portal</strong><span>Admin Console</span></div>
          <button className="sidebar-close" onClick={closeNavigation}><X size={21} /></button>
        </div>

        <nav className="sidebar-nav" aria-label="Admin navigation">
          <NavLink to="/" end className={navItemClass} onClick={closeNavigation}>
            <LayoutDashboard size={19} /><span>Dashboard</span>
          </NavLink>
          {isSuperAdmin ? (
            <NavLink to="/analytics" className={navItemClass} onClick={closeNavigation}>
              <BarChart3 size={19} /><span>App Analytics</span>
            </NavLink>
          ) : null}

          <p className="nav-label">Portal content</p>
          {can('village', 'view') ? (
            <NavLink to="/village" className={navItemClass} onClick={closeNavigation}>
              <VILLAGE_MODULE.icon size={19} /><span>{VILLAGE_MODULE.label}</span>
            </NavLink>
          ) : null}
          {moduleLinks.map(([key, module]) => (
            <NavLink key={key} to={`/content/${key}`} className={navItemClass} onClick={closeNavigation}>
              <module.icon size={19} /><span>{module.label}</span>
            </NavLink>
          ))}

          {(isSuperAdmin || can('adminUsers', 'view') || can('auditLogs', 'view')) ? <p className="nav-label">Administration</p> : null}
          {isSuperAdmin ? (
            <NavLink to="/app-settings" className={navItemClass} onClick={closeNavigation}>
              <Settings2 size={19} /><span>App Settings</span>
            </NavLink>
          ) : null}
          {(isSuperAdmin || can('adminUsers', 'view')) ? (
            <NavLink to="/admins" className={navItemClass} onClick={closeNavigation}>
              <UserCog size={19} /><span>Admin Users</span>
            </NavLink>
          ) : null}
          {(isSuperAdmin || can('auditLogs', 'view')) ? (
            <NavLink to="/audit-logs" className={navItemClass} onClick={closeNavigation}>
              <Activity size={19} /><span>Audit Logs</span>
            </NavLink>
          ) : null}
        </nav>

        <div className="sidebar-footer">
          <ShieldCheck size={18} />
          <div><strong>{isSuperAdmin ? 'Super Admin' : 'Admin'}</strong><span>Secure Firebase access</span></div>
        </div>
      </aside>

      {mobileOpen ? <button className="sidebar-scrim" aria-label="Close navigation" onClick={closeNavigation} /> : null}

      <div className="main-column">
        <header className="topbar">
          <button className="menu-button" onClick={() => setMobileOpen(true)} aria-label="Open navigation"><Menu size={22} /></button>
          <div className="topbar-title">
            <span>Jashapar Gram Panchayat</span>
            <small>Content Management System</small>
          </div>
          <div className="profile-menu">
            <button className="profile-trigger" onClick={() => setProfileOpen((value) => !value)}>
              <span className="avatar">{String(adminProfile?.name || adminProfile?.email || 'A').charAt(0).toUpperCase()}</span>
              <span className="profile-copy"><strong>{adminProfile?.name || 'Admin'}</strong><small>{adminProfile?.email}</small></span>
              <ChevronDown size={17} />
            </button>
            {profileOpen ? (
              <div className="profile-dropdown">
                <div><strong>{adminProfile?.name}</strong><span>{adminProfile?.email}</span></div>
                <button onClick={logout}><LogOut size={17} /> Sign out</button>
              </div>
            ) : null}
          </div>
        </header>

        <main className="page-content" key={location.pathname}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
